<template lang="html">
  <modal-template
    ref="modal"
    modal-size="sm"
    title="Adicionar novo tipo"
    type-modal="add_type_option_modal"
  >
    <div class="modal-content__main">
      <d-form @submit="save()">

        <d-form-row>
          <d-col md="12" class="form-group">
            <label for="feName">Nome</label>
            <d-form-input type="text" v-model="model.name" id="feName" placeholder="Nome" />
          </d-col>
        </d-form-row>

      </d-form>
    </div>

    <div slot="actions" class="modal-content__control" >
      <d-button
        type="button"
        @click="cancel()"
        class="btn btn-sm btn-secondary mr-4"
      >Cancelar</d-button>
      <d-button
        type="button"
        @click="save()"
        class="btn btn-sm btn-primary"
      >Salvar</d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import { stringfy } from '_utils';
import Events from '_utils/events';
import ModalTemplate from '_shared/Modal.vue';
import ProductService from '_services/rest/modules/product';
import { EQUIPMENT_DEFAULT } from '_constants/equipment';
import { _RELOAD_TYPE_ } from '../ProductModel';

export default {
  name: 'add-type-option',
  components: {
    ModalTemplate,
  },
  props: {},
  data() {
    return {
      loading: false,
      model: { ...EQUIPMENT_DEFAULT },
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    cancel() {
      this.setToggle({ type: 'add_type_option_modal', bool: false });
    },
    save() {
      this.toggleLoading();
      this.model.slug = stringfy(this.model.name);
      ProductService.saveTypeOption(this.model)
        .then(() => {
          this.cancel();
          Events.$emit(_RELOAD_TYPE_);
        })
        .catch(error => this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' }))
        .finally(() => this.toggleLoading());
    },
    toggleLoading() {
      this.loading = !this.loading;
      Events.$emit('loading', this.loading);
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>

</style>
